"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROXY_API = exports.BASE_URL = void 0;
var proxyDomain = process.env.REACT_APP_PROXY_API_URL;
exports.BASE_URL = "".concat(proxyDomain, "/api");
exports.PROXY_API = {
    GET: {
        SIGN_IN: {
            REFRESH_TOKEN: 'signin/refreshtoken',
        },
        HEREMAP: {
            TOKEN: '/heremaps/token',
        },
    },
};
